import { array, string } from 'fp-ts';

export const nullIfEmptyString = (input: string) => (string.isEmpty(input) ? null : input);
export const nullIfEmptyArray = <T>(input: T[]) => (array.isEmpty(input) ? null : input);
